module.exports = __webpack_public_path__ + "static/media/32-14.bd7ef9fe.mp3";